import Layout from "./Layout";

const Description = ({ pointOfInterest }) => {
    return (
        <Layout title="Descriere">
            <p id="descriptionPoi">{pointOfInterest.description}</p>
        </Layout>
    );
};

export default Description;
